import QuoteHighlight from './QuoteHighlight';

export default QuoteHighlight;
